var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 140.9 101.7" },
      attrs: {
        version: "1.1",
        id: "Ebene_3",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 140.9 101.7",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M93.674,41.33c0-13.41-10.871-24.281-24.281-24.281s-24.28,10.872-24.28,24.282\n\tc0,7.978,3.849,15.057,9.79,19.484C48.06,63.799,42.3,68.801,38.375,75.069",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M109.415,77.12c-8.444,12.5-22.745,20.719-38.965,20.719c-25.951,0-46.989-21.038-46.989-46.989\n\tS44.499,3.861,70.45,3.861c18.116,0,33.838,10.252,41.68,25.271",
        },
      }),
      _vm._v(" "),
      _c("g", [
        _c("polygon", {
          staticClass: "st1",
          attrs: {
            points:
              "110.377,40.205 120.633,54.079 87.084,78.878 68.878,81.608 76.828,65.003 \t",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "st1",
          attrs: {
            d: "M120.633,54.079l-10.256-13.874l0,0l5.345-3.951c2.616-1.933,6.473-1.355,8.406,1.261l3.026,4.094\n        c1.933,2.616,1.355,6.473-1.261,8.406L120.633,54.079L120.633,54.079L120.633,54.079z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }